"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalRoutes = void 0;
const route_1 = require("../route");
class WithdrawalRoutes extends route_1.Route {
    constructor() {
        super('withdrawals');
    }
    withdraw(amount, linkedAccountId) {
        return this.post('/', { amount, linkedAccountId });
    }
    /** Get the user's current status on withdrawal limits.
     * Returns an object with items:
     * maxMonthlyWithdrawalSum
     * currentMonthlyWithdrawalSum
     * maxWeeklyWithdrawalSum
     * currentWeeklyWithdrawalSum
     */
    getLimitStatus() {
        return this.get('/limit');
    }
}
exports.WithdrawalRoutes = WithdrawalRoutes;
//# sourceMappingURL=withdrawals.js.map